module.exports = __webpack_public_path__ + "static/media/cruce.47ea7cb4.svg";